import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c72cbdb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1c72cbdb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c72cbdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c72cbdb')) {
      api.createRecord('1c72cbdb', component.options)
    } else {
      api.reload('1c72cbdb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1c72cbdb&scoped=true", function () {
      api.rerender('1c72cbdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/assess/check/index.vue"
export default component.exports